<div class="pager-button-container" [style.background-color]="backgroundColor" (click)="onClick($event)">
	<img [src]="srcString | resolveAsset" draggable="false" class="icon" alt="img" />
</div>
